import { Working } from '@ui/Working';
import { ShareQuestionAndAnswer } from '@containers/DigitalAnalyst/components/ShareQuestionAndAnswer';
import { ResultRatingForm } from '@containers/form/ResultRatingForm';
import { ResultContext, RUNNING_STATUS } from '@/contexts/ResultContext';
import { Body5, Container } from '@ui';
import React from 'react';
import { RefiningAnswer } from './components/RefiningAnswer';
import { AnswerConfigContext } from '@/contexts/AnswerConfigContext';

import { QueryControllerContext } from '@/contexts/QueryControllerContext';
import { AgentAnswer } from './components/AgentAnswer';
import { AgentExecutedPlan } from './components/AgentExecutedPlan';

export const AgentStreamingResultStatus = () => {
  const { runningStatus } = React.useContext(ResultContext);
  if (runningStatus === RUNNING_STATUS.RUNNING) {
    return <Working />;
  }
  if (runningStatus === RUNNING_STATUS.REFINING) {
    return <RefiningAnswer />;
  }
  return null;
};

const AgentStreamingResult = () => {
  const { enableRating, enableShare } = React.useContext(AnswerConfigContext);
  const { resultId, runningStatus, answer } = React.useContext(ResultContext);
  const { prevQueryFormData } = React.useContext(QueryControllerContext);

  return (
    <Container>
      <Container bottom={16}>
        <Body5 bold>Answer:</Body5>
      </Container>
      <AgentStreamingResultStatus />
      <Container left={16}>
        <AgentAnswer />
      </Container>
      <Container top={16}>
        <AgentExecutedPlan />
      </Container>
      {/* <ContextSources top={16} /> */}
      {/* <NewsSources top={16} /> */}
      {runningStatus === RUNNING_STATUS.COMPLETED && enableRating && (
        <Container top={16}>
          <ResultRatingForm resultId={resultId} />
        </Container>
      )}
      {runningStatus === RUNNING_STATUS.COMPLETED && enableShare && (
        <Container top={36}>
          <ShareQuestionAndAnswer question={prevQueryFormData.question} answer={answer} buttonWidth="240px" />
        </Container>
      )}
      <Container top={16} />
    </Container>
  );
};

export default AgentStreamingResult;
